export default function OnlyNumbers() {
  let checkOnKeypress = function () {};
  let checkOnPaste = function () {};
  const constraints = {
    min: 0,
    max: 100000,
  };

  return {
    mounted(el, { value, modifiers }) {
      checkOnKeypress = function (event) {
        const result = event.target.value + String.fromCharCode(event.charCode);
        return handler(event, result);
      };

      checkOnPaste = function (event) {
        const result = event.clipboardData.getData("text/plain");
        return handler(event, result);
      };

      function handler(e, result) {
        let REGEX = /^\d*$/g;
        if (modifiers.decimal) {
          REGEX = /^\d*?(?:\.\d*)?$/g;
        }

        if (!REGEX.test(result)) {
          return e.preventDefault();
        }

        if (!value) {
          return;
        }

        const resultNumber = +result;
        if (
          (value.min >= 0 && resultNumber < constraints.min) ||
          (value.max >= 0 && resultNumber > constraints.max)
        ) {
          return e.preventDefault();
        }
      }

      el.addEventListener("keypress", checkOnKeypress);
      el.addEventListener("paste", checkOnPaste);
    },

    updated(el, { value }) {
      if (!value) {
        return;
      }
      constraints.min = value.min;
      constraints.max = value.max;
    },

    unmounted(el) {
      el.removeEventListener("keypress", checkOnKeypress);
      el.removeEventListener("paste", checkOnPaste);
    },
  };
}
